var _a;
import { __decorate, __metadata, __param } from "tslib";
import { AbstractModel, ContributionProvider, Disposable } from '@patsnap/tahiti-core';
import { inject, injectable, named } from 'inversify';
import { DataTypeActionContribution } from '../data-type-action-contribution';
function isEnabled() {
    return true;
}
function isVisible() {
    return true;
}
let DataTypeActionRegistryImpl = class DataTypeActionRegistryImpl extends AbstractModel {
    constructor(_contributionProvider) {
        super();
        this._contributionProvider = _contributionProvider;
        this._modelData = { actions: [] };
        this._commandIds = new Set();
    }
    clone(modelData) {
        const data = { actions: modelData.actions.map(_ => {
                return { ..._ };
            }) };
        return data;
    }
    dispose() {
        this._commandIds.clear();
        this.update(() => ({ actions: [] }));
    }
    onStart() {
        this._contributionProvider.getContributions().forEach(contribution => {
            contribution.registerDataTypeActions(this);
        });
        return this;
    }
    registerAction(action) {
        if (this._commandIds.has(action.commandId)) {
            console.warn(`Data type action with command ID ${action.commandId} already exists.`);
            return Disposable.NULL;
        }
        const actions = this.modelData.actions;
        const _action = this._normalizeAction(action);
        actions.push(_action);
        this.update(() => ({ actions }));
        this._commandIds.add(action.commandId);
        return {
            dispose: () => {
                this._disposeAction(action);
            },
        };
    }
    getActions(dataType) {
        const actions = this.modelData.actions
            .filter(action => {
            return action.whenDataType === dataType
                || action.whenDataType === undefined;
        });
        return actions.sort((a, b) => a.order - b.order);
    }
    _normalizeAction(action) {
        return {
            ...action,
            isEnabled: action.isEnabled || isEnabled,
            isVisible: action.isVisible || isVisible,
            tooltip: action.tooltip || (() => undefined),
            order: action.order || 0,
        };
    }
    _disposeAction(action) {
        const actions = this.modelData.actions;
        const index = actions.findIndex(a => a.commandId === action.commandId);
        if (index !== -1) {
            actions.splice(index, 1);
            this.update(() => ({ actions }));
            this._commandIds.delete(action.commandId);
        }
    }
};
DataTypeActionRegistryImpl = __decorate([
    injectable(),
    __param(0, inject(ContributionProvider)),
    __param(0, named(DataTypeActionContribution)),
    __metadata("design:paramtypes", [typeof (_a = typeof ContributionProvider !== "undefined" && ContributionProvider) === "function" ? _a : Object])
], DataTypeActionRegistryImpl);
export { DataTypeActionRegistryImpl };
